import cn from 'classnames';
import { AnchorHTMLAttributes, FC, LegacyRef, ReactElement } from 'react';

interface ILinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'className'> {
  startIcon?: ReactElement;
  endIcon?: ReactElement;
  elementRef?: LegacyRef<HTMLAnchorElement>;
  classNames?: {
    root?: string;
    startIcon?: string;
    endIcon?: string;
    text?: string;
  };
}

const Link: FC<ILinkProps> = (props) => {
  const { classNames, startIcon, endIcon, elementRef, children, ...rest } = props;

  return (
    <a className={cn('link', classNames?.root)} ref={elementRef} {...rest}>
      {startIcon && (
        <span className={cn('link_icon link_icon-start', classNames?.startIcon)}>{startIcon}</span>
      )}
      <span className={cn('link-text', classNames?.text)}>{children}</span>
      {endIcon && (
        <span className={cn('link_icon link_icon-end', classNames?.endIcon)}>{endIcon}</span>
      )}
    </a>
  );
};

export default Link;
